import React from 'react';
import ToggleButton from './ToggleButton';
import { GetCopy } from '../util/GetCopy';
import { useNavigate } from 'react-router-dom';

const Hero = ({ showCopy = false, brand = null, setNextAdIndex,setSelectedFormat }) => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className={`${showCopy ? null : 'brandHero'} hero `}>
      {showCopy && (
        <>
          <span className="caption">
            <GetCopy copy="ad gallery" />
          </span>
          <h3 className="mt-3 text-center mb-4">
            <GetCopy copy="header" />
          </h3>
          <p className="pb-3" style={{ maxWidth: '500px', textAlign: 'center', padding: '0 15px' }}>
            <GetCopy copy="header description" />
          </p>
          <ToggleButton setNextAdIndex={setNextAdIndex}/>
        </>
      )}
      {!showCopy && (
        <>
          <span>
            <button className="breadcumbButton caption" onClick={goBack}>
              <GetCopy onClick={goBack} copy="ad gallery" />
            </button>
            <span className="breadcrumBrand caption">{'  > '}</span>
            <span className="breadcrumBrand bcCurrent caption">{brand}</span>
          </span>
        </>
      )}
    </div>
  );
};

export default Hero;
